import { useState, useCallback, useEffect } from 'react';

const store = {};

export const getStoredState = (key) => store[key];

const storeState = (key, value) => {
  store[key] = value;
};

export default function useMemoryStorage(
  key,
  initialValue,
  isToResetInitialState
) {
  let initialState;
  if (isToResetInitialState) {
    initialState = initialValue;
  } else {
    initialState = store[key] || initialValue;
  }

  const [state, setState] = useState(initialState);

  // Adicionado o useCallback para ter o mesmo comportamento do hook original,
  // que não recria a função a cada render
  const handleSetState = useCallback((value) => {
    setState((previousValue) =>
      value instanceof Function ? value(previousValue) : value
    );
  }, []);

  useEffect(() => {
    storeState(key, state);
  }, [key, state]);

  return [state, handleSetState];
}
